import {
  OrganizationContactUpdateRequest,
  OrganizationCreateRequest,
  OrganizationCreateResponse,
  OrganizationGeneralUpdateRequest,
  OrganizationGetAllInsuranceParams,
  OrganizationGetAllInsurancesResponse,
  OrganizationGetAllResponse,
  OrganizationGetResponse,
  OrganizationSearch,
  OrganizationUpdateResponse,
} from '@quromedical/models';
import { trpc } from 'trpc';

export class OrganizationApi {
  public async getOrganization(id: string): Promise<OrganizationGetResponse> {
    const result = await trpc.client.organization.getById.query({ id });

    return result;
  }

  public async createOrganization(
    organization: OrganizationCreateRequest
  ): Promise<OrganizationCreateResponse> {
    return await trpc.client.organization.create.mutate(organization);
  }

  public async updateOrganizationContact(
    params: OrganizationContactUpdateRequest
  ): Promise<OrganizationGetResponse> {
    return await trpc.client.organization.updateContact.mutate({
      ...params,
    });
  }

  public async updateOrganizationGeneral(
    params: OrganizationGeneralUpdateRequest
  ): Promise<OrganizationUpdateResponse> {
    return await trpc.client.organization.updateGeneral.mutate({
      ...params,
    });
  }

  public async getInsuranceOrganizations(
    params?: OrganizationGetAllInsuranceParams
  ): Promise<OrganizationGetAllInsurancesResponse> {
    return await trpc.client.organization.getAllInsurance.query({ ...params });
  }

  public async getAll(params: OrganizationSearch): Promise<OrganizationGetAllResponse> {
    return await trpc.client.organization.getAll.query({
      ...params,
    });
  }
}
